import React from 'react'
import { useIntl } from 'react-intl'
import { Popover, Skeleton } from 'antd'
import cn from 'classnames'

import styles from './LoadingInvalidData.module.scss'

const LoadingInvalidData = ({ popoverClassName, paragraph = {}, title = {} }) => {
  const { formatMessage } = useIntl()
  return (
    <Popover
      content={formatMessage({ id: 'financeProduct.data_is_being_processed' })}
      className={cn('d-flex', popoverClassName)}
    >
      {Array(3)
        .fill(undefined)
        .map((__, index) => (
          <Skeleton
            // eslint-disable-next-line react/no-array-index-key
            key={index}
            active
            title={{
              style: { borderRadius: 999999, width: 12, height: 12 },
              ...title,
            }}
            paragraph={{ rows: 0, ...paragraph }}
            className={`${styles.hppSkeleton} mx-1 d-flex align-items-center`}
          />
        ))}
    </Popover>
  )
}

export default LoadingInvalidData
